const BoxTitle = ({ title }) => <h1 className="text-center font-bold text-lg mb-2">{title}</h1>

export default BoxTitle
